import { render, staticRenderFns } from "./ReopenTaskForm.vue?vue&type=template&id=2dc71ae2&"
import script from "./ReopenTaskForm.vue?vue&type=script&lang=ts&"
export * from "./ReopenTaskForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports